import { type CookieInfoApi } from '../../models/api.model'
import { ESMApiService } from './esm-api.service'
import { UMDApiService } from './umd-api.service'

export class PublicApiService {
  private static instance: PublicApiService
  private readonly esmApiService: ESMApiService
  private readonly umdApiService: UMDApiService

  private constructor() {
    this.esmApiService = ESMApiService.getInstance()
    this.umdApiService = UMDApiService.getInstance()
  }

  static getInstance(): PublicApiService {
    if (PublicApiService.instance === undefined) {
      PublicApiService.instance = new PublicApiService()
    }

    return PublicApiService.instance
  }

  getESMCookieInfoApi(): CookieInfoApi {
    return this.esmApiService.getPublicApi()
  }

  createUMDPublicObject(): void {
    this.umdApiService.createGlobalApiObject()
  }
}
